<template>
  <div>
    <el-select
      :placeholder="$t('Seçin')"
      filterable
      :value="selected || null"
      @input="handleInput"
      style="width: 100%"
    >
      <el-option
        v-for="item in data"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { usersbyrole } from "../../services/sales";

export default {
  props: {
    value: [Number, String],
  },
  data() {
    return {
      data: [],
      selected: this.value,
      roleIds: [63, 64, 65, 66, 79, 80, 81],
    };
  },
  methods: {
    handleInput(e) {
      this.$emit("input", e);
      this.selected = e;
    },
    async getData() {
      const promises = this.roleIds.map((roleId) => usersbyrole(roleId));

      try {
        const responses = await Promise.all(promises);
        const allData = responses.flatMap((response) => response.data || []);

        const uniqueData = allData.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.name === item.name)
        );

        this.data = uniqueData;

        if (this.data.length === 0) {
          this.$message({
            type: "error",
            message: "Signers users: No data found!",
          });
        }
      } catch (error) {
        this.$message({
          type: "error",
          message: "Error fetching data for users!",
        });
      }
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    value() {
      this.selected = this.value;
    },
  },
};
</script>

<style lang="scss" scoped></style>
